import "./App.css";
import About from "./components/About/About";
import Contact from "./components/Contact/Contact";
import Navbar from "./components/Navbar/Navbar";
import Projects from "./components/Projects/Projects";
import Skills from "./components/Skills/Skills";
import Achievements from "./components/Achievements/Achievements";
import SEO from "./SEO";
import Footer from "./components/Footer/Footer";
import Info from "./components/About/Info";
import Experiences from "./components/Experiences/Experiences";

function App() {
	return (
		<main className='text-gray-400 bg-gray-900 body-font'>
			<SEO />
			<Navbar />
			<About />
			<Info />
			<Experiences />
			<Projects />
			<Skills />
			<Achievements />
			<Contact />
			<Footer />
		</main>
	);
}

export default App;
